import styled from 'styled-components';

const NextPreStepsStyle = styled.div`
	&.actionBtn {
		--svgWidth: 82px;
		--svgHeight: 20px;
		--arrowMarg: var(--sp4x);

		margin-top: var(--inputMarg);
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		.NextBtnDescription {
			flex: 1 1 100%;
			text-align: right;
			opacity: 0;
		}

		.actionBtnItem {
			flex: 0 0 50%;
			cursor: pointer;
			display: flex;

			.svg {
				width: var(--svgWidth);
				height: var(--svgHeight);
				margin-top: var(--sp4x);
				margin-bottom: var(--sp3x);

				svg {
					overflow: visible;
					fill: var(--color2);
				}
			}

			&.preBtnWrap {
				.svg {
					margin-left: var(--arrowMarg);

					svg {
						transform: rotateY(180deg);
						transform-origin: center;
					}
				}
			}

			&.nextBtnWrap {
				justify-content: flex-end;

				.svg {
					margin-right: var(--arrowMarg);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--inputMarg: var(--sp8x);
			--svgWidth: 102px;
			--svgHeight: 26px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--inputMarg: var(--sp10x);
			--svgWidth: 119px;
			--svgHeight: 30px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--inputMarg: var(--sp13x);
			--svgWidth: 130px;
			--svgHeight: 32px;

			.actionBtnItem {
				.svg {
					margin-top: var(--sp5x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--inputMarg: var(--sp13x);
			--svgWidth: 170px;
			--svgHeight: 45px;

			.actionBtnItem {
				.svg {
					margin-top: var(--sp8x);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--inputMarg: var(--sp15x);
			--svgWidth: 250px;
			--svgHeight: 63px;
			--arrowMarg: var(--sp6x);

			.actionBtnItem {
				.svg {
					margin-top: var(--sp10x);
				}
			}
		}
	}
`;

export default NextPreStepsStyle;
